import { Injectable } from "@angular/core";
import { RestService } from "../core/core/rest.service";
import { Issue, IssueElement } from "../issues/issues.model";
import { ObjectToSelect } from "../core/shared/objectToSelect.model";
import { ProjectWatcher } from "../projects/projects.model";

@Injectable()
export class IssuesExtRest {
    constructor(private http: RestService) { }

    public checkIfIssueHasElements(id: number) {
        return this.http.get<boolean>(`api/issueexternal/checkIfIssueHasElements/${id}`);
    }
    
    public removeIssue(id: number) { 
        return this.http.post(`api/issueexternal/deleteIssue/${id}`, {});
    }

    public getIssue(issueId: number) {
        return this.http.get<Issue>(`api/issueexternal/issue/${issueId}`);
    }

    public createEmptyIssue(employeeId: number, customerId: number) {
        return this.http.get<Issue>(`api/issueexternal/createEmptyIssue/${employeeId}/${customerId}`);
    }

    public saveIssue(issue: Issue, isNew: boolean) {
        return this.http.post(`api/issueexternal/saveIssue/${isNew}`, issue);
    }

    public saveElement(element: IssueElement, isNew: boolean) {        
        return this.http.post(`api/issueexternal/saveElement/${isNew}`, element);
    }

    public removeElement(element: IssueElement) {
        return this.http.post(`api/issueexternal/removeElement/${element.id}/${element.issueId}`, {});
    }

    public copyIssue(issueId: number) {
        return this.http.post<Issue>(`api/issueexternal/copyIssue`, issueId);
    }

    public getEmptySystemVersion() {
        return this.http.get<number>(`api/issueexternal/getEmptySystemVersion`);
    }

    public getIssueElements(issueId: number) {
        return this.http.get<IssueElement[]>(`api/issueexternal/issue/elements/${issueId}`);
    }

    public removeWatcher(id: number) {
        return this.http.post(`api/issueexternal/removeWatcher/${id}`, {});
    }

    public getCustomerEmployees(customerId: number, issueAssigneeId: number) {
        return this.http.get<ObjectToSelect[]>(`api/issueexternal/getCustomerEmployees/${customerId}/${issueAssigneeId}`);
    }
    public getSystemVersions(customerId: number) {
        return this.http.get<ObjectToSelect[]>(`api/issueexternal/getSystemVersions/${customerId}`);
    }

    public getIssueTypes() {
        return this.http.get<ObjectToSelect[]>(`api/issueexternal/issueTypes`);
    }

    public getEmployees() {
        return this.http.get<ObjectToSelect[]>(`api/issueexternal/employees`);
    }

    public getDepartments() {
        return this.http.get<ObjectToSelect[]>('api/issueexternal/departments');
    }

    public getStates(isElement: boolean) {
        return this.http.get<ObjectToSelect[]>(`api/issueexternal/states/${isElement}`);
    }

    public getCustomerProjectStepsForIssue(customerId: number, objectId: number){
        return this.http.get<ObjectToSelect[]>(`api/issueexternal/getCustomerProjectStepsForIssue/${customerId}/${objectId}`);
    }

    public getProjectWatchersByProjectStepId(projectStepId: number) {
        return this.http.get<ProjectWatcher[]>(`api/issueexternal/getProjectWatchersByProjectStepId/${projectStepId}`);
    }

}